export const arkoseVerifyEndpoint = 'https://snap-verify.arkoselabs.com/api/v4/verify/';
export const arkosePublicDevKey = '1A7AAF5C-0F05-4719-BFD4-2A7C94BE53AE';
export const arkosePublicProdKey = '664578B2-FE27-4BE6-952F-E1023A4BA422';
